// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2mrCH","icon":"SortAdornment_icon__1-zem","up":"SortAdornment_up__21HRa","down":"SortAdornment_down__1jizL","active":"SortAdornment_active__1yWVA"};